import React from "react";

export type DataTableSkeletonProps = {
  columnCount: number;
  rowCount?: number;
  className?: string;
};

export default function DataTableSkeleton({
  columnCount,
  rowCount = 8,
  className = "",
}: DataTableSkeletonProps) {
  const cols = Math.max(1, columnCount);
  const rows = Math.max(1, rowCount);

  return (
    <div
      className={["overflow-hidden rounded-lg border border-light-grey bg-white", className]
        .filter(Boolean)
        .join(" ")}
      role="status"
      aria-busy="true"
      aria-label="Loading table"
    >
      <div className="border-b border-light-grey bg-medium-grey px-4 py-3">
        <div className="grid gap-3" style={{ gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))` }}>
          {Array.from({ length: cols }).map((_, i) => (
            <div key={`h-${i}`} className="h-4 animate-pulse rounded bg-light-grey" />
          ))}
        </div>
      </div>
      <div className="divide-y divide-light-grey">
        {Array.from({ length: rows }).map((_, r) => (
          <div key={`r-${r}`} className="px-4 py-4">
            <div className="grid gap-3" style={{ gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))` }}>
              {Array.from({ length: cols }).map((_, c) => (
                <div key={`c-${r}-${c}`} className="h-4 animate-pulse rounded bg-light-grey" />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
